var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mask-side-section-container",
    { attrs: { title: _vm.$t("MirrorTo") } },
    [
      _c(
        "v-flex",
        { staticClass: "mb-2", attrs: { shrink: "" } },
        [
          _c(
            "input-field",
            {
              attrs: {
                value: _vm.destinationMask,
                label: "Internal Destination",
                inputType: "other",
                size: "large"
              }
            },
            [
              _c(
                "div",
                [
                  _c("treeselect", {
                    staticClass: "form-input-select",
                    attrs: {
                      options: _vm.internalMirrorMaskOptions,
                      placeholder: "Mask",
                      disableFuzzyMatching: ""
                    },
                    model: {
                      value: _vm.destinationMask,
                      callback: function($$v) {
                        _vm.destinationMask = $$v
                      },
                      expression: "destinationMask"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "4px 20px" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "accent",
                  attrs: {
                    small: "",
                    block: "",
                    round: "",
                    disabled: !_vm.destinationMask
                  },
                  on: {
                    click: function($event) {
                      _vm.mirrorDialog = true
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("content_copy")
                  ]),
                  _c("span", [_vm._v("Apply")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.mirrorDialog,
          title: _vm.$t("InternalMirror"),
          content: _vm.$t("ConfirmApplyMirror"),
          "secondary-action-label": _vm.$t("No"),
          "main-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: _vm.mirrorInternally,
          secondaryAction: _vm.cancelMirror
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b114c32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b114c32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskMirror.vue
// module id = null
// module chunks = 